import apiHandler from '@api/ApiHandler.ts';

/**
 * @param callback
 * @param notification_id
 * @returns The updated notification
 * */
export const updateNotification = async (
  notification_id: number,
  callback: (data: any) => void
) => {
  apiHandler
    .patch(`notification/${notification_id}/`)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error:', error);
      callback({} as any); // or handle the error as you see fit
    });
};
